{
  "info": "Information",
  "warn": "Warning",
  "success": "Success",
  "ok": "OK",
  "cancel": "Cancel",
  "save": "Save",
  "yes": "Yes",
  "no": "No",
  "back": "Back",
  "browse": "Browse",
  "delete": "Delete",
  "remove": "Remove",
  "loggedOut": "Logged out",
  "error": {
    "title": "Error",
    "server": "The server returned an error. Please try again later.",
    "network": "Network connection error. Please check your network settings.",
    "unknown": "An unknown system error occurred."
  },
  "sessionExpired": {
    "idle": {
      "summary": "Idle Timeout",
      "detail": "You have been logged out due to inactivity. Please log in again."
    },
    "tokenExpired": {
      "summary": "Session Expired",
      "detail": "Your session has expired. Please log in again."
    }
  }
}